/**
 * Walks every collection results page (same URL scheme as ?page=N) and recounts
 * model years (data-model-year) and tag handles (data-product-tag-handles).
 */
(function () {
  function parseProductsFromDoc(doc) {
    var years = Object.create(null);
    var tagHandles = Object.create(null);
    var nodes = doc.querySelectorAll('.products-listing .product-layout');
    nodes.forEach(function (el) {
      var y = el.getAttribute('data-model-year');
      if (y) years[y] = (years[y] || 0) + 1;
      var th = el.getAttribute('data-product-tag-handles');
      if (th) {
        String(th)
          .split('||')
          .forEach(function (h) {
            h = (h || '').trim();
            if (h) tagHandles[h] = (tagHandles[h] || 0) + 1;
          });
      }
    });
    return { years: years, tagHandles: tagHandles, count: nodes.length };
  }

  function mergeAgg(total, part) {
    Object.keys(part.years).forEach(function (k) {
      total.years[k] = (total.years[k] || 0) + part.years[k];
    });
    Object.keys(part.tagHandles).forEach(function (k) {
      total.tagHandles[k] = (total.tagHandles[k] || 0) + part.tagHandles[k];
    });
  }

  function fetchPage(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('fetch ' + url);
      return res.text();
    });
  }

  function aggregateAllPages(baseUrl, perPage) {
    var total = { years: Object.create(null), tagHandles: Object.create(null) };
    var page = 1;
    return (function next() {
      var url =
        page === 1
          ? baseUrl
          : baseUrl + (baseUrl.indexOf('?') >= 0 ? '&' : '?') + 'page=' + page;
      return fetchPage(url).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var part = parseProductsFromDoc(doc);
        mergeAgg(total, part);
        if (part.count === 0) return total;
        if (part.count < perPage) return total;
        page += 1;
        if (page > 500) return total;
        return next();
      });
    })();
  }

  function applyYearTitleList(agg, sectionId) {
    var root = document.querySelector('.collection-filter-year--title.js-year-title-derived');
    if (!root) return;
    var ol = root.querySelector('.js-year-filter-list');
    if (!ol) return;
    ol.innerHTML = '';
    var keys = Object.keys(agg.years).filter(function (k) {
      return agg.years[k] > 0;
    });
    keys.sort(function (a, b) {
      return parseInt(b, 10) - parseInt(a, 10);
    });
    keys.forEach(function (y) {
      var li = document.createElement('li');
      li.className = 'filter-figma-radio-row';
      li.setAttribute('data-recount-year', y);
      li.setAttribute('data-count-source', 'title');
      var id = 'filter-year-title-' + sectionId + '-' + y;
      li.innerHTML =
        '<input type="checkbox" id="' +
        id +
        '" value="' +
        y +
        '"/>' +
        '<label for="' +
        id +
        '">' +
        y +
        '</label>';
      ol.appendChild(li);
    });
  }

  function applySidebarCounts(agg) {
    document.querySelectorAll('li[data-recount-tag-handle]').forEach(function (li) {
      if (li.closest('.filter-year-block')) return;
      var h = li.getAttribute('data-recount-tag-handle');
      var n = h ? agg.tagHandles[h] || 0 : 0;
      li.style.display = n > 0 ? '' : 'none';
    });
  }

  window.recalculateCollectionFilterCounts = function () {
    var ctx = document.getElementById('collection-filter-recount-context');
    if (!ctx) return Promise.resolve();
    var baseUrl = ctx.getAttribute('data-base-url');
    var perPage = parseInt(ctx.getAttribute('data-per-page'), 10) || 24;
    var sectionId = ctx.getAttribute('data-section-id') || 's';
    if (!baseUrl) return Promise.resolve();

    return aggregateAllPages(baseUrl, perPage)
      .then(function (agg) {
        applyYearTitleList(agg, sectionId);
        applySidebarCounts(agg);
        if (typeof window.initCollectionYearTitleFilter === 'function') {
          window.initCollectionYearTitleFilter();
        }
      })
      .catch(function (e) {
        console.warn('[collection-filter-full-counts]', e);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.recalculateCollectionFilterCounts();
    });
  } else {
    window.recalculateCollectionFilterCounts();
  }
})();
